/**
 * Informações institucionais centralizadas.
 * Qualquer alteração de telefone, email ou redes sociais é feita aqui.
 */
export const COMPANY = {
  name: 'Teia de Eventos',
  legalName: 'Âmbar Produções LTDA',
  cnpj: '04.859.743/0001-72',
  description:
    'Há mais de 26 anos planejando, organizando e executando eventos corporativos, culturais e turísticos.',
  address: {
    street: 'Rua Pastor Meyer, 04 - Casa 04',
    neighborhood: 'Centro',
    city: 'Nova Friburgo',
    state: 'RJ',
    zip: '28625-116',
    full: 'Rua Pastor Meyer, 04 - Casa 04 - Centro - Nova Friburgo/RJ - CEP: 28625-116',
  },
  contact: {
    phone: '(22) 2522-6942',
    phoneDigits: '552225226942',
    whatsapp: '(22) 98829-3467',
    whatsappDigits: '5522988293467',
    email: 'teia@teiadeeventos.com.br',
  },
  hours: 'Segunda a sexta, das 8h30 às 18h',
  social: {
    instagram: 'https://www.instagram.com/teiadeeventos',
    facebook: 'https://www.facebook.com/eventosteia2/',
    linkedin: 'https://www.linkedin.com/company/teia-de-eventos',
  },
  related: {
    estanciaCampestre: {
      name: 'Estância Campestre',
      description:
        'Espaço completo para eventos, festas e cerimônias, na Estrada Friburgo-Teresópolis.',
      instagram: 'https://www.instagram.com/estancia.campestre/',
    },
  },
} as const;

/**
 * Helper para gerar URL do WhatsApp com mensagem pré-preenchida.
 */
export const whatsappUrl = (message?: string): string => {
  const base = `https://wa.me/${COMPANY.contact.whatsappDigits}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
};
